import { Component, OnInit } from '@angular/core';
import {TipoQuimicos} from '../../../models/tipo-quimicos.model';
import {CatalogosService} from '../../../services/catalogos.service';
@Component({
  selector: 'app-lista-quimicos',
  templateUrl: './lista-quimicos.component.html',
  styleUrls: ['./lista-quimicos.component.css']
})
export class ListaQuimicosComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Productos Químicos',
      routerLink: '/quimicos'
    }
  ];

  tipos: TipoQuimicos[];
  loading = false;

  constructor(private catalogosService: CatalogosService) { }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposQuimicos().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }

}
